export async function startSignatureGenerate(setfinalData, setsigned, buyerData, transactionDetails) {
    const myData = {};
    // Merchant details
    myData["merchant_id"] = process.env.REACT_APP_PAYFAST_MERCHANT_ID;
    myData["merchant_key"] = process.env.REACT_APP_PAYFAST_MERCHANT_KEY;
    myData["return_url"] = "https://newro.co.za/return";
    myData["cancel_url"] = "https://newro.co.za/cancel";
    myData["notify_url"] = "https://payfastsecuritycheck-rgzicncala-uc.a.run.app";
    // Buyer details
    // myData["name_first"] = buyerData['userName'];
    // myData["name_last"] = "Last Name";
    // myData["email_address"] = buyerData['email'];
    // Transaction details
    myData["m_payment_id"] = transactionDetails['orderId'];
    myData["amount"] = transactionDetails['amount'];
    myData["item_name"] = transactionDetails['itemName'];

    // Generate signature
    // const myPassphrase = "jt7NOE43FZPn";

    const generateSignatureResponse = await generateSignature(myData,);
    // console.log("generateSignatureResponse: " + JSON.stringify(generateSignatureResponse))

    myData["signature"] = generateSignatureResponse.signature;
    setfinalData(myData)
    setsigned(true)
}

async function generateSignature(data) {
    // console.log("Generateing")
    return fetch("https://generatepayfastsignature-rgzicncala-uc.a.run.app", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            data: {
                ...data
            }
        })
    }).then(res => res.json())
        .then(data => {
            return data
        }).catch((error) =>
            console.log("Fetch Error: " + error)
        );

};

export const PaymentForm = ({ pfHost, finalData }) => {
    // console.log("PFD: " + JSON.stringify(finalData))
    return (
        <form action={`https://${pfHost}/eng/process`} method="post">
            {Object.entries(finalData).map(([key, value]) => (
                value.trim() !== "" && (
                    <input
                        key={key}
                        type="hidden"
                        name={key}
                        value={value.trim()}
                    />
                )
            ))}
            <input type="image" src="https://my.payfast.io/images/buttons/PayNow/Light-Large-PayNow.png" alt="Pay Now" title="Pay Now with Payfast" />
        </form>
    );
};